import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService {
  private router = inject(Router);

  private currentUrl?: string;

  private previousUrl?: string;

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const nextUrl = event.urlAfterRedirects;
        if (nextUrl === this.currentUrl) {
          return;
        }

        this.previousUrl = this.currentUrl;
        this.currentUrl = nextUrl;
      });
  }

  navigateBack(fallbackUrl = '/'): Promise<boolean> {
    return this.router.navigateByUrl(this.previousUrl ?? fallbackUrl);
  }
}
